import React from "react";
import contentfulReleaseNotesFactory, {
	fetchProps,
} from "@insightfulscience/contentful/Apps/ReleaseNotes";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import Page from "../../contentful/Apps/ReleaseNotes/Page";
import resources from "../../../locales";
import { contentfulProps } from "../../config";

const releaseNotesLayout = ({ children }) => {
	const [t] = useLocale("releaseNotes");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContenfulReleaseNotesApp = contentfulReleaseNotesFactory({
	Layout: pipe(releaseNotesLayout, WithLocale({ resources })),
	Page,
	contentfulProps,
	pageProps: {
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.post
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContenfulReleaseNotesApp;
